import { modifiedApiRequest } from "./util";

export const fetchBannedWords = async () => {
  try {
    let res = await modifiedApiRequest("bannedWords", "GET");

    if (!Array.isArray(res) || res.length === 0) {
      console.warn("[v0] No banned words found");
      return {};
    }

    const grouped = {};
    res.forEach((item) => {
      const category = item.category || "uncategorized";
      if (!grouped[category]) {
        grouped[category] = [];
      }
      grouped[category].push(item.word);
    });

    // console.log(
    //   `[v0] Successfully grouped ${data.length} banned words into ${
    //     Object.keys(grouped).length
    //   } categories`
    // );
    return grouped;
  } catch (err) {
    console.error("[v0] Failed to fetch banned words:", err);
    return {};
  }
};
